module.exports = __webpack_public_path__ + "static/icon_milano_nordovest_nero-0e54ecaf7c2fbea8349c0971b06233a7.svg";